<template>

    <loader v-if="loading"></loader>
    <div v-else style="padding: 20px">
        <div class="header">
            <h2>Bus</h2>
            <el-button type="primary" @click="show_add_bus = true">Add new Bus</el-button>
        </div>

        <add-bus-company v-if="show_add_bus" @close="show_add_bus = false"></add-bus-company>
        <el-table
                :data="all_buses.filter(el => el.lineName.toLowerCase().includes(search.toLowerCase()))"
                height="80vh"
        >
            <el-table-column
                    prop="companyName"
                    label="Name"
            >
            </el-table-column>
            <el-table-column
                    prop="lineName"
                    label="Line">
            </el-table-column>
            <el-table-column
                    prop="distance"
                    label="Distance">
            </el-table-column>
            <el-table-column
                    prop="price"
                    label="Price">
            </el-table-column>
            <el-table-column
                    prop="time"
                    label="Time">
            </el-table-column>
            <el-table-column
                    align="right">
                <template slot="header">
                    <label>
                        <input
                                v-model="search"

                                class="no-border-input"
                                style="padding: 5px; border-radius: 4px"
                                size="mini"
                                placeholder="Type to search"/>
                    </label>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {mapMutations, mapState} from "vuex";
    import BusService from '@/common/services/bus.service'
    import mutations from "@/store/mutation_types";
    import Loader from "../common/components/loader";
    import AddBusCompany from "../components/bus/AddCompany";

    export default {
        name: 'Bus',
        components: {AddBusCompany, Loader},
        data() {
            return {
                taxi: [],
                search: '',
                loading: false,
                show_add_bus:false
            }
        },
        computed: {
            ...mapState({
                user: state => state.user,
                all_buses: state => state.buses
            }),

            filterTaxi() {
                let search = this.search.toLowerCase();
                return this.all_taxi_types.filter(el => el.name.includes(search) || el.cityName.includes(search))
            }

        },
        methods: {
            ...mapMutations(['SET_BUSES']),
        },
        beforeMount() {
            this.loading = true;
            let payload = {
                "email": this.user.user_email,
                "cityName": "TETOVO"
            };
            BusService.getBuses(payload).then(response => {
                this[mutations.SET_BUSES](response.data)
            }).catch(error => {
                this.$notify.error({
                    title: `Failed to buses`,
                    message: error.response.data.message
                });
            }).finally(() => this.loading = false)

        }
    }
</script>

<style scoped lang="scss">
    .header {
        display: flex;
        justify-content: space-between;
        padding: 10px 10px;
        align-items: center;
    }
</style>
